import React, { Component } from 'react';

export const RoleList = [
	{
		groupid: 'dashboard',
		menuid: 'dashboard',
		groupname: 'Dashboard',
		path: '#/dashboard'
	},
	{
		groupid: 'settings',
		groupname: 'Settings',
		subgroups: [
			{
				menuid: 'zones',
				menuname: 'Zones',
				path: '#/settings/zones'
			},
			{
				menuid: 'services',
				menuname: 'Services',
				path: '#/settings/services'
			},
			{
				menuid: 'institutions',
				menuname: 'Institutions',
				path: '#/settings/institutions'
			},
			{
				menuid: 'postcategory',
				menuname: 'Post Category',
				path: '#/settings/postcategory'
			},
			{
				menuid: 'qualification',
				menuname: 'Qualification',
				path: '#/settings/qualification'
			},
			{
				menuid: 'subject',
				menuname: 'Subjects',
				path: '#/settings/subject'
			},
			{
				menuid: 'university',
				menuname: 'Universities',
				path: '#/settings/university'
			},
			{
				menuid: 'renew',
				menuname: 'Renewal Setup',
				path: '#/settings/renewmonth'
			},
			{
				menuid: 'specialtraining',
				menuname: 'Special Training',
				path: '#/settings/specialtraining'
			}
		]
	},
	{
		groupid: 'candidate',
		groupname: 'Employment',
		subgroups: [
			{
				menuid: 'registration',
				menuname: 'Employment Registration',
				path: '#/candidate/registration'
			},
			{
				menuid: 'registration',
				menuname: 'Seniority List',
				path: '#/candidate/list'
			},
			{
				menuid: 'registration',
				menuname: 'Renewal',
				path: '#/candidate/renewal'
			}
		]
	},
	{
		groupid: 'appointment',
		groupname: 'Appointment',
		subgroups: [
			{
				menuid: 'interview',
				menuname: 'Vacancy Details',
				path: '#/appointment/addvacancy'
			},
			{
				menuid: 'interview',
				menuname: 'Called for Interview',
				path: '#/appointment/interview'
			},
			{
				menuid: 'interview',
				menuname: 'Appointment Order',
				path: '#/appointment/order'
			}
		]
	}
];